import {
  Row,
  Col,
  Card,
  Table,
  DatePicker,
  Tag,
  Radio,
  Modal,
  Button,
} from "antd";

import React, { useState, useEffect } from "react";
import { DeleteOutlined, InfoCircleOutlined } from "@ant-design/icons";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";

function LastAppointments({ data, loading, refresh }) {
  const { request } = useRequest();
  const [list, setList] = useState(data);
  const [pagination, setPagination] = useState(5);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedMF, setSelectedMF] = useState();
  const [mfList, setMfList] = useState();
  const [currentMf, setCurrentMf] = useState();
  const [cpModalVisible, setCpModalVisible] = useState(false);
  const [certifiedPractitioners, setCertifiedPractitioners] = useState([]);
  useEffect(() => {
    if (!data) return;
    setList(data);
    setPagination(data?.length);
    console.log("data ::", data);
    setMfList(data);
  }, [data]);

  const handleReassignAndDelete = async () => {
    try {
      request({
        url: apiPath.dashboard + `/${currentMf}?selectedMf=${selectedMF}`,
        method: "DELETE",
        onSuccess: ({ data }) => {
          refresh();
        },
        onError: (error) => {},
      });
      setDeleteModalVisible(false);
    } catch (err) {
      console.error(err);
    }
  };

  const openDeleteModal = (record) => {
    setSelectedMF(null);
    setDeleteModalVisible(true);
    setCurrentMf(record?._id);
    // setMfList((prevList) => prevList.filter((item) => item._id !== record._id));
  };

  const openCpModal = (cps) => {
    setCertifiedPractitioners(cps);
    setCpModalVisible(true);
  };

  const cpModalColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <div>{record.name || record.userName || "N/A"}</div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text) => <div>{text || "N/A"}</div>,
    },
  ];
  const columns = [
    {
      title: "Name",
      render: (_, { name, userName }) => {
        return <div>{name ? name : userName}</div>;
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (_, { email }) => {
        return <div>{email || "-"}</div>;
      },
    },
    // {
    //   title: "Assigned Certified Practitioner",
    //   dataIndex: "mfWithMPs",
    //   key: "mfWithMPs",
    //   render: (_, { master_practitioner }) => {
    //     return (
    //       <div className="certified-practitioner-tags">
    //         {(master_practitioner || []).map((mp) => (
    //           <Tag key={mp._id}>{mp.name || mp.userName || "N/A"}</Tag>
    //         ))}
    //         {master_practitioner.length > 0 && (
    //           <Button
    //             icon={<InfoCircleOutlined />}
    //             onClick={() => openCpModal(master_practitioner)}
    //             className="info-btn"
    //           />
    //         )}
    //       </div>
    //     );
    //   },
    // },

    {
      title: "Assigned Certified Practitioner",
      dataIndex: "mfWithMPs",
      key: "mfWithMPs",
      render: (_, { master_practitioner }) => {
        const practitioners = master_practitioner || [];
        return (
          <div className="certified-practitioner-tags">
            {practitioners.slice(0, 2).map((mp) => (
              <Tag key={mp._id}>{mp.name || mp.userName || "N/A"}</Tag>
            ))}
            {practitioners.length > 0 && (
              <Button
                icon={<InfoCircleOutlined />}
                onClick={() => openCpModal(practitioners)}
                className="info-btn"
              />
            )}
          </div>
        );
      },
    },

    {
      title: "Action",
      render: (_, record) => (
        <div className="cta_wrap">
          <Button title="Delete" onClick={() => openDeleteModal(record)}>
            <i className="fa fa-trash"></i>
          </Button>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="tabled bannerMain">
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <div className="table-responsive customPagination">
              <Table
                loading={loading}
                columns={columns}
                dataSource={list}
                pagination={{
                  defaultPageSize: 10,
                  responsive: true,
                  total: pagination,
                  // showSizeChanger: true,
                  // pageSizeOptions: ["10", "20", "30", "50"],
                }}
                className="ant-border-space"
              />
            </div>
          </Col>
        </Row>
      </div>
      <Modal
        title="Delete Master Facilitator"
        open={deleteModalVisible}
        onCancel={() => setDeleteModalVisible(false)}
        onOk={handleReassignAndDelete}
        okButtonProps={{ disabled: !selectedMF }}
        okText="Reassign & Delete"
      >
        <p>
          Select a new Master Facilitator or Admin to reassign their Certified
          Practitioners:
        </p>
        <Radio.Group
          onChange={(e) => setSelectedMF(e.target.value)}
          value={selectedMF}
          style={{ display: "flex", flexDirection: "column", gap: "10px" }}
        >
          {mfList
            ?.filter((mf) => mf._id !== currentMf)
            .map((mf) => (
              <Radio key={mf._id} value={mf._id}>
                {mf.name || mf.userName} ({mf.type === "admin" ? "Admin" : "MF"}
                )
              </Radio>
            ))}
        </Radio.Group>
      </Modal>

      <Modal
        title="Certified Practitioners"
        open={cpModalVisible}
        onCancel={() => setCpModalVisible(false)}
        footer={[
          <Button key="back" onClick={() => setCpModalVisible(false)}>
            Close
          </Button>,
        ]}
      >
        <Table
          columns={cpModalColumns}
          dataSource={certifiedPractitioners}
          rowKey="_id"
          pagination={false}
        />
      </Modal>
    </>
  );
}

export default LastAppointments;
